import React from 'react';

interface ZoomProps {
  zoomLevel: number;
  minZoom: number;
  maxZoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
}

const Zoom: React.FC<ZoomProps> = ({
  zoomLevel,
  minZoom,
  maxZoom,
  onZoomIn,
  onZoomOut,
  onResetZoom,
}) => {
  return (
    <div className="flex items-center justify-end ">
      <button
        onClick={onZoomOut}
        disabled={zoomLevel <= minZoom}
        className="m-0.5 px-2 py-0.5 bg-gray-200 hover:bg-gray-100 rounded text-xs text-black disabled:opacity-50"
        title="Zoom Out (Ctrl + -)"
      >
        A -
      </button>

      <button
        onClick={onResetZoom}
        className="m-0.5 px-2 py-0.5 bg-gray-200 hover:bg-gray-100 rounded text-xs text-black disabled:opacity-50"
        title="Reset Zoom (Ctrl + 0)"
      >
        {zoomLevel}%
      </button>

      <button
        onClick={onZoomIn}
        disabled={zoomLevel >= maxZoom}
        className="m-0.5 px-2 py-0.5 bg-gray-200 hover:bg-gray-100 rounded text-xs text-black disabled:opacity-50"
        title="Zoom In (Ctrl + =)"
      >
        A +
      </button>
    </div>
  );
};

export default Zoom;